export enum AppEnv {
  testing = 'testing',
  staging = 'staging',
  production = 'production'
}
